/** @jsx h */
import { h } from 'preact';
import { useState, useEffect } from 'preact/hooks';
import Menu from '../../header/menu';
import style from './style.css';
import { connect } from 'react-redux';
import BICRevampHeader from '../../header/bicRevampHeader';
import GenericFooter from '../../../../componentsBICRevamp/common/genericFooter';
import BottomNav from './bottomNav';
import { isNavMenuRoute } from '../../../../utils/navBar';
import { useWindowDimension } from '../../../../utils/useWindowDimension';
import Utils, { getSessionStorage } from '../../../../utils';
import ntbAction from '../../../../actions/ntbAction';
import actionType from '../../../../actions/ntbAction/actionType';
import {
  howToBuyProductRoute,
  howToBuyRoute,
} from '../../../../alias/homeRoutes';

type Props = {
  isHeaderFixed: boolean,
  shouldShowBrandingHeader: boolean,
  shouldShowSearchBar: boolean,
  shouldShowFilterHeader: boolean,
  template: string,
};

const BICRevampContainer = (props: Props) => {
  const {
    isHeaderFixed,
    shouldShowBrandingHeader,
    shouldShowSearchBar,
    shouldShowFilterHeader,
    template,
    pathFromStore,
    mobile,
    ntbAction,
    userStatus,
    isLoggedIn,
  } = props;

  useEffect(() => {
    const authDetails = getSessionStorage('authDetails');
    if (authDetails && userStatus !== 'eligible' && mobile) {
      const authDetailsParsed = JSON.parse(authDetails);
      ntbAction(actionType.getLenderList, authDetailsParsed);
    }
  }, [mobile]);

  const [menuState, changeMenuState] = useState(false);
  const [showBottomNav, setShowBottomNav] = useState(false);
  const shouldHeaderDisplay =
    shouldShowBrandingHeader || shouldShowSearchBar || shouldShowFilterHeader;
  const path = window.location.pathname;
  const [dimention] = useWindowDimension();
  const [width] = dimention;

  useEffect(() => {
    checkShowBottomNav();
  }, [pathFromStore]);

  const checkShowBottomNav = () => {
    if (isNavMenuRoute()) {
      setShowBottomNav(true);
    } else {
      setShowBottomNav(false);
    }
  };
  const renderFooter = () => {
    return !(
      (path.includes(howToBuyRoute.internalRoute) ||
        path.includes(howToBuyProductRoute.internalRoute)) &&
      width < 769
    );
  };

  const minHeightValues = {
    ['how-to-buy']: {
      minHeight: width > 769 ? 'calc(100vh - 215px)' : '',
    },
  };

  const minHeight = () => {
    return path.includes(howToBuyRoute.internalRoute) ||
      path.includes(howToBuyProductRoute.internalRoute)
      ? minHeightValues['how-to-buy'].minHeight
      : '100vh';
  };
  return (
    <div
      className={`${style.container} bicRevampContainer ${
        template === 'neutral' ? style.backgroundBodyOverride : ''
      }`}>
      {shouldHeaderDisplay && (
        <BICRevampHeader
          menuState={menuState}
          changeMenuState={changeMenuState}
          isCategoryPage={false}
        />
      )}
      {menuState && (
        <Menu menuState={menuState} changeMenuState={changeMenuState} />
      )}
      <div style={{ minHeight: minHeight() }} className={style.bodyContainer}>
        {props.children}
      </div>
      {renderFooter() && <GenericFooter />}
      {showBottomNav && <BottomNav />}
    </div>
  );
};

const mapStateToProps = ({
  bicConfig,
  config,
  ntbConfig,
  userLogin,
  identifyUser,
}) => {
  const {
    isHeaderFixed,
    shouldShowBrandingHeader,
    shouldShowSearchBar,
    shouldShowFilterHeader,
  } = bicConfig;
  const { userStatus } = ntbConfig;
  const { template, routeDetails } = config;
  const { path: pathFromStore } = routeDetails;
  const { authDetails } = identifyUser;
  const { m: mobile } = authDetails;
  const { isLoggedIn } = userLogin;
  return {
    isHeaderFixed,
    shouldShowBrandingHeader,
    shouldShowSearchBar,
    shouldShowFilterHeader,
    template,
    pathFromStore,
    mobile,
    userStatus,
    isLoggedIn,
  };
};

export default connect(
  mapStateToProps,
  { ntbAction },
)(BICRevampContainer);



// WEBPACK FOOTER //
// ./components/partial/container/bicRevampContainer/index.js